import queryString from 'query-string'
import apiV2 from '.'

export const emailsV3Api = apiV2.injectEndpoints({
  endpoints: builder => ({
    getEmailsV3: builder.query({
      query: ({ domainId, eventId, type }) => `/domains/${domainId}/events/${eventId}/emails/v3?${queryString.stringify({ type })}`,
      transformResponse: response => response.data.emails,
      providesTags: ['EMAILS_V3'],
    }),
    sendEmailV3: builder.mutation({
      query: ({ domainId, eventId, userId, userIds, email, emailId, variables, label, actionId, languageId }) => ({
        url: `/domains/${domainId}/events/${eventId}/emails/v3/send`,
        method: 'POST',
        body: { userId, userIds, email, variables, label, emailId, actionId, languageId },
      }),
      invalidatesTags: ['EMAILS_V3'],
    }),
  }),
})

export const { useGetEmailsV3Query, useSendEmailV3Mutation } = emailsV3Api
